import { useNavigate } from 'react-router-dom';
import { useTonConnectUI } from '@tonconnect/ui-react';
import { toNano } from '@ton/core';
import BackButton from './BackButton';
import './WalletPage.css';
import React, { useState, useEffect } from 'react';

const WalletPage = () => {
  const navigate = useNavigate();                 
  const [tonConnectUI] = useTonConnectUI();        
  const ensureConnected = async () => {
  if (!tonConnectUI.wallet) {
    await tonConnectUI.openModal(); // Откроет окно подключения кошелька
  }
};
  const handlePayment = async () => {
    try {
      await ensureConnected();
      // 1) Формируем транзакцию для контракта
      const transaction = {
        validUntil: Math.floor(Date.now() / 1000) + 300, // дедлайн через 5 минут
        messages: [
          {
            address: 'kQAQ1zM6LOUIsRUC7e1kNFAXn-RkjK5fvUfrJJie4laZIZWO',
            amount: toNano('0.005').toString(),          // конвертируем в нанотоны :contentReference[oaicite:4]{index=4}
          },
        ],
      };

      // 2) Открываем кошелёк и ждём подписи от пользователя
      const result = await tonConnectUI.sendTransaction(transaction);
      console.log('Signed BOC:', result.boc);

      // 3) Перенаправление или уведомление об успешной отправке
      navigate('/success');
    } catch (error) {
      console.error('Ошибка при отправке транзакции:', error);
      // Можно показать модальное окно ошибки или уведомление
    }
  };

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, []);

  return (
    <div className="container">
      {loading ? (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
      ) : (
    <div className="wallet-page">
      <div className="overlay"></div>
      <form className="text-form">
        <h2 class="search-form__fieldset-title">Состояние кошелька</h2>
        <div className="wallet-row">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">USDT</span>
            <p class="expedition__value">100</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">MARS</span>
            <p class="expedition__value">100</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">St. Mars</span>
            <p class="expedition__value">100</p>
          </label>
        </fieldset>
      </div>  
      </form>
      <button onClick={handlePayment} className="layer-button pay-button">
        Оплатить
      </button>
      <form className="text-form">
        <h2 class="search-form__fieldset-title">Запущенная экспедиция 1</h2>
        <div className="wallet-row">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Прошло</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Осталось</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Доход</span>
            <p class="expedition__value">1000</p>
          </label>
        </fieldset>
        </div>
      </form>
      <form className="text-form">
        <h2 class="search-form__fieldset-title">Запущенная экспедиция 2</h2>
        <div className="wallet-row">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Прошло</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Осталось</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Доход</span>
            <p class="expedition__value">1000</p>
          </label>
        </fieldset>
        </div>
      </form>
      <form className="text-form">
        <h2 class="search-form__fieldset-title">Запущенная экспедиция 3</h2>
        <div className="wallet-row">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Прошло</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Осталось</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Доход</span>
            <p class="expedition__value">1000</p>
          </label>
        </fieldset>
        </div>
      </form>
      <form className="text-form">
        <h2 class="search-form__fieldset-title">Запущенная экспедиция 4</h2>
        <div className="wallet-row">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Прошло</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Осталось</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Доход</span>
            <p class="expedition__value">1000</p>
          </label>
        </fieldset>
        </div>
      </form>
      <form className="text-form">
        <h2 class="search-form__fieldset-title">Запущенная экспедиция 5</h2>
        <div className="wallet-row">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Прошло</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Осталось</span>
            <p class="expedition__value">15</p>
          </label>
        </fieldset>
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Доход</span>
            <p class="expedition__value">1000</p>
          </label>
        </fieldset>
        </div>
      </form>
      <button className="layer-button save-button">
        Потребовать страховку
      </button>
      <BackButton onClick={() => navigate('/fork')} />
    </div>
    )}
    </div>
  );
};

export default WalletPage;